import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from '../config';
import placeholderImage from "../images/Placeholder.png";
import categoryAll from "../images/categoryAll.jpg";


function Categories() {

    const [categories, setCategories] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [categoryImages, setCategoryImages] = useState(null);
    const [categoryCount, setCategoryCount] = useState(null);
    const [botanicalItemCount, setBotanicalItemCount] = useState(0);
    const [crystalItemCount, setCrystalItemCount] = useState(0);


    useEffect(() => {
        const processProductCategories = async () => {

            try {
                const response = await axios.get(`${API_BASE_URL}/api/categories`);
                let tempObject = {
                    crystals: [],
                    botanicals: [],
                }
                let tempCatImages = new Map();
                let tempCatCount = new Map();
                let botanicalCount = 0;
                let crystalCount = 0;
                const products = response.data;

                if (response.data.length > 0) {
                    for (let product of products) {
                        if (product.category.toLowerCase() === "crystals") {
                            if (!tempObject.crystals.includes(product.subcategory)) tempObject.crystals.push(product.subcategory)
                            if (!tempCatImages.has(product["subcategory"])) tempCatImages.set(product["subcategory"], product?.["imageURL"]?.[0])
                            if (tempCatImages.has(product["subcategory"]) && tempCatImages.get(product["subcategory"]) == "") tempCatImages.set(product["subcategory"], product?.["imageURL"]?.[0])
                            crystalCount = crystalCount + 1;
                            tempCatCount.has(product.subcategory) ? tempCatCount.set(product.subcategory, tempCatCount.get(product.subcategory) + 1) : tempCatCount.set(product.subcategory, 1)
                        } else if (product.category.toLowerCase() === "botanicals") {
                            if (!tempObject.botanicals.includes(product.subcategory)) tempObject.botanicals.push(product.subcategory)
                            if (!tempCatImages.has(product["subcategory"])) tempCatImages.set(product["subcategory"], product?.["imageURL"]?.[0])
                                if (tempCatImages.has(product["subcategory"]) && tempCatImages.get(product["subcategory"]) == "") tempCatImages.set(product["subcategory"], product?.["imageURL"]?.[0])

                            tempCatCount.has(product.subcategory) ? tempCatCount.set(product.subcategory, tempCatCount.get(product.subcategory) + 1) : tempCatCount.set(product.subcategory, 1)
                            botanicalCount = botanicalCount + 1;
                        }
                    }
                    setCategories(tempObject);
                    setBotanicalItemCount(botanicalCount);
                    setCrystalItemCount(crystalCount);
                    setCategoryImages(tempCatImages);
                    setCategoryCount(tempCatCount);
                    
                    return () => {
                        console.log("Done")
                    };
                }
            } catch (error) {
                console.error("Error fetching products:", error);

            }
        }
        processProductCategories();

    }, [])


    return (
        <div style={{ position: "relative", margin: "3rem" }}>
            <h1 className="centered-subtitle" style={{ marginTop: "2rem" }}>Shop by Category</h1>

            <h2 className="category-h2-title">Botanicals</h2>
            <h4 className="category-h4-title"><Link to="/botanicals">View All ({botanicalItemCount} items) <i className="bi bi-arrow-right"></i></Link></h4>

            <section className="category-flex-container category-flex-container-botanicals">
                {categories == null ? "No categories found." : [...categories["botanicals"]].map(category => {
                    return (
                        <article className="category-flex-subcontainer" >
                            <Link to={`/botanicals?category=${encodeURIComponent(category)}`} className="category-image-container" style={{ backgroundImage: `url(${categoryImages.get(category) == ("" || undefined) ? placeholderImage : categoryImages.get(category)})` }}>
                                <div>View {categoryCount.get(category)} items <i className="bi bi-arrow-right"></i></div>
                            </Link>
                            <h3>{category}</h3>

                        </article>
                    );
                })}
            </section>
            <h2 className="category-h2-title category-h2-title-crystals">Crystals</h2>
            <h4 className="category-h4-title category-h4-title-crystals"><Link to="/crystals">View All ({crystalItemCount} items) <i className="bi bi-arrow-right"></i></Link></h4>
            <section className="category-flex-container category-flex-container-crystals">
                {categories == null ? "No categories found." : [...categories["crystals"]].map(category => {
                    return (
                        <article className="category-flex-subcontainer" >
                            <Link to={`/crystals?category=${encodeURIComponent(category)}`} className="category-image-container" style={{ backgroundImage: `url(${categoryImages.get(category) == ("" || undefined) ? placeholderImage : categoryImages.get(category)})` }}>
                                <div>View {categoryCount.get(category)} items <i className="bi bi-arrow-right"></i></div>
                            </Link>
                            <h3>{category}</h3>

                        </article>
                    );
                })}
            </section>
            <div className="category-divider"></div>
            <section className="category-shop-all">
                <article className="category-flex-subcontainer-all" >
                    <Link to="/all" className="category-image-container" style={{ backgroundImage: `url(${categoryAll})`, aspectRatio: "1.5", backgroundPositionY: "50%", borderRadius: "10px" }}>
                        <div>View {crystalItemCount + botanicalItemCount} items <i className="bi bi-arrow-right"></i></div>
                    </Link>
                    <h3>View All</h3>

                </article>
            </section>
        </div >
    );
}

export default Categories;